import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toasts.
 *
 * The theme follows the document's own data-theme attribute rather than a
 * second source of truth, so a toast is never light-on-light after the theme
 * toggle. Colours come from the same CSS variables as everything else.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
